<template>
  <form @submit.prevent="getList()" method="GET" novalidate>
    <div class="card-body">
      <div class="form-row">
        <div class="col-md-6">
          <div class="form-group from-row">
            <label class="col-md-3 col-form-label" for="course_id"
              >Course</label
            >
            <div class="col-md-9">
              <multiselect
                id="course_id"
                name="course_id"
                :options="Object.keys(courseOps)"
                :custom-label="(opt) => courseOps[opt]"
                v-bind:class="{ 'has-error': errors.has('course_id') }"
                v-validate="'required'"
                v-model="search.queryable_id"
                class="course_id"
                placeholder="Select Course"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
              ></multiselect>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-9">
              <button type="submit" class="btn btn-common m-2px">
                <i class="fas fa-search"></i> Search
              </button>
              <button
                type="reset"
                class="btn btn-warning"
                @click="resetFilter()"
              >
                <i class="fas fa-undo"></i> Reset
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
export default {
  props: ["filter", "courseOps"],
  data: () => ({
    search: {},
  }),
  methods: {
    resetFilter() {
      this.search = {};
      this.getList();
    },
    getList() {
      this.$emit("updateFilter", {
        filter: this.search,
      });
    },
  },
};
</script>
